import i18n, { i18n as I18n } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend, { HttpBackendOptions } from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

export const initI18n = async (): Promise<I18n> => {
  await i18n
    // Load translation using http -> see /public/locales
    // Learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // Detect user language
    // Learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // Init i18next
    // For all options read: https://www.i18next.com/overview/configuration-options
    .init<HttpBackendOptions>({
      returnNull: false,
      fallbackLng: 'en',
      load: 'currentOnly',
      interpolation: {
        // Not needed for react as it escapes by default
        escapeValue: false,
      },
      backend: {
        loadPath: '/locale/{{lng}}.json',
        requestOptions: {
          cache: 'no-store',
        },
      },
    })

  return i18n
}
